import styled, { css } from 'styled-components';

import { BRAND_COLORS } from 'brand-guidelines/colors';
import { TYPOGRAPHY } from 'brand-guidelines/typography';
import { SelectButton } from 'common/components/ToggleSelect/styled-components';
import { Radio } from 'opencare-crown';

export const ToggleSelectGroup = styled(Radio.Group).attrs({ buttonStyle: 'solid', tabIndex: 0 })`
  display: flex;
  align-self: stretch;
`;

type ToggleSelectOptionProps = {
  $isInvalid?: boolean;
};

export const ToggleSelectOption = styled(SelectButton)<ToggleSelectOptionProps>`
  && {
    ${TYPOGRAPHY.CIRCULAR.bold}

    padding: 13px 24px;
    font-size: 16px;
    line-height: 20px;
    color: ${BRAND_COLORS.darkStroke};

    ${({ $isInvalid }) => $isInvalid && css`
      border-color: ${BRAND_COLORS.darkRed};
    `}

    &:focus-within {
      outline: none !important;
    }

    &.ant-radio-button-wrapper:first-child {
      border-radius: 8px 0 0 8px;
    }

    &.ant-radio-button-wrapper:last-child {
      border-radius: 0 8px 8px 0;
    }
  }
`;
